<template>
  <div>
    <div class="md-layout" v-if="false">
      <md-button class="md-dense md-primary" v-on:click="botao_voltar" v-if="botao_voltar_visible">
        <md-icon>arrow_back</md-icon>Voltar para lista
      </md-button>
    </div>
    <div class="md-layout" v-if="show_message == 'on' ">
      <div class="alert alert-success">{{message_text}}</div>
    </div>

    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Dados Básicos</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Nome</label>
              <div class="md-layout-item md-size-60 md-xsmall-size-70">
                <md-field>
                  <md-input name="nome" type="text" placeholder="Nome" v-model="form.nome"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('nome') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Finalidade</label>
              <div class="md-layout-item md-size-60 md-xsmall-size-70">
                <md-field>
                  <md-select v-model="form.id_finalidade" name="id_finalidade" id="id_finalidade">
                    <md-option
                      v-for="item in finalidade_list"
                      :key="item.id"
                      :value="item.id"
                    >{{item.descricao}}</md-option>
                  </md-select>
                </md-field>

                <span class="error_input">{{ getErrors('id_finalidade') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Data de Validade</label>
              <div class="md-layout-item md-size-20 md-xsmall-size-70">
                <md-field>
                  <!-- :clear-button=true  -->
                  <datepicker
                    format="dd/MM/yyyy"
                    :typeable="true"
                    inputClass="md-input"
                    name="data_validade"
                    v-model="data_validade"
                    :language="language_date"
                    calendar-button-icon-content="event"
                    :input="datepicker_inputchanged"
                  ></datepicker>
                </md-field>

                <span class="error_input">{{ getErrors('data_validade') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Status</label>
              <div class="md-layout-item md-size-20 md-xsmall-size-70">
                <md-field>
                  <md-select v-model="form.status" name="status" id="status">
                    <md-option
                      v-for="item in status_list"
                      :key="item.value"
                      :value="item.value"
                    >{{item.label}}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-20 md-xsmall-size-100">
                <md-checkbox v-model="cliente_oculto">O modelo é cliente oculto?</md-checkbox>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Descrição</label>
              <div class="md-layout-item md-size-60 md-xsmall-size-70">
                <md-field>
                  <md-textarea
                    v-model="form.descricao"
                    name="descricao"
                    id="descricao"
                    style="height: 50px"
                  ></md-textarea>
                </md-field>

                <span class="error_input">{{ getErrors('descricao') }}</span>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <CardCadastro v-if="show_categoria_grid">
        <div slot="header">
          <h4 class="title">Categorias deste CheckList</h4>
        </div>
        <div slot="body">
          <div class="md-layout">
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <md-field>
                <vue_select
                  class="vue-select2"
                  name="id_categoria_add"
                  :options="categoria_list"
                  v-model="id_categoria_add"
                  :label_selected.sync="nome_categoria_add"
                  :searchable="true"
                  language="pt-BR"
                ></vue_select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-15 md-xsmall-size-30">
              <md-button class="md-info" v-on:click="add_categoria()">Adicionar</md-button>
              <md-button class="md-info" v-if="false" v-on:click="loadbyId()">Reload</md-button>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100" v-if="show_categoria_items">
              <div style="max-height: 300px; overflow-y: scroll">
                <list_categoria_modelo
                  v-model="items_categoria"
                  :id_pai="form.id"
                  :ids_excluir.sync="ids_excluir_categoria"
                ></list_categoria_modelo>
              </div>
            </div>
          </div>
        </div>
      </CardCadastro>

      <div class="md-layout-item md-size-100">
        <div class="btn-right">
          <md-button
            class="md-info"
            type="button"
            v-bind:disabled="disableButton"
            v-on:click="salvar()"
          >Salvar</md-button>

          <md-button
            class="md-danger"
            type="button"
            v-bind:disabled="disableButton"
            v-if="form != null && form.id != null && form.id !='' && parseInt(form.id) > 0"
            v-on:click="excluir()"
          >Excluir</md-button>
        </div>
      </div>

      <md-dialog :md-active.sync="showDialogError">
        <md-tabs md-dynamic-height>
          <md-tab md-label="Erros">
            <ul class="list-group" v-if="p_validator.errors != null ">
              <li
                v-for="(item, index) in p_validator.errors"
                class="list-group-item"
                :key="index"
                style="text-align: left"
              >{{item.msg}}</li>
            </ul>
            <center>
              <md-button class="md-danger" type="button" @click="hideModal">OK</md-button>
            </center>
          </md-tab>
        </md-tabs>
      </md-dialog>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import service from "../../../services/ModeloChecklistService";
import serviceItens from "../../../services/ModeloChecklistItensService";
import serviceCadastro from "../../../services/CadastroBasicoService";
import serviceCategoria from "../../../services/CategoriaService";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";

import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";
import Util from "../../../library/Util";

import CardCadastro from "../../../components/CardCadastro";
import list_categoria_modelo from "../modelo_checklist_itens/list_categoria_modelo";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";

import swal from "sweetalert2";

export default {
  components: {
    autocomplete,
    filelogo,
    modal,
    Datepicker,
    list_categoria_modelo,
    CardCadastro,
    vue_select
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],

      finalidade_list: [],
      status_list: [],

      cliente_oculto: false,

      show_perfil: false,
      file_upload: null,

      botao_voltar_visible: true,

      loading: true,

      result2: "",
      disableButton: false,

      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,

      msg_status: "Carregando",

      show_modal_contacts: false,
      show_sub_form: true,
      show_categoria_grid: false,

      data_validade: null, //new Date()
      language_date: ptBR,

      items_categoria: [],
      categoria_list: [],
      id_categoria_add: null,
      nome_categoria_add: "",

      ids_excluir_categoria: [],

      show_categoria_items: true
    };
  },
  mounted() {
    let self = this;
    this.form = service.getModel();
    this.status_list = service.getListStatusOptions();

    this.configureMessages();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    serviceCategoria.getList("", "nome", "asc").then(function(response) {
      self.categoria_list = Util.getListToSelect(response.data, "id", "nome");
    });

    this.disableButton = true;
    this.show_categoria_grid = false;

    serviceCadastro
      .getList("", "3", "descricao", "asc")
      .then(function(response) {
        self.finalidade_list = response.data;
      });

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      this.loadbyId();
    } else {
      this.loading = false;
      this.disableButton = false;
      this.show_categoria_grid = true;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "modelo_checklist",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    loadbyId() {
      var self = this;

      service.getById(this.id_load).then(function(response) {
        if (response.data.data != null && response.data.data != undefined) {
          self.form = response.data.data;

          if (self.form.data_validade != null) {
            var intData = self.getApiDateInt(self.form.data_validade);

            self.data_validade = new Date(intData);
          }

          self.cliente_oculto =
            self.form.cliente_oculto != null && self.form.cliente_oculto == 1;
          self.show_categoria_grid = true;
        } else {
          self.form = response.data.item;
        }
        self.loading = false;
        self.disableButton = false;
      });
    },

    add_categoria() {
      var id = this.id_categoria_add;

      if (
        this.id_categoria_add == null ||
        this.id_categoria_add.toString() == ""
      ) {
        swal.fire("Atenção", "Selecione uma categoria.", "warning");

        return false;
      }

      var filt = this.items_categoria.filter(function(item) {
        return item.id_categoria.toString() == id.toString();
      });

      if (filt.length > 0) {
        swal.fire("Atenção", "Esta categoria já foi adicionada", "warning");
        return false;
      }

      var itemNovo = serviceItens.getModelCategoria();
      itemNovo.id_categoria = this.id_categoria_add;
      itemNovo.categoria_nome = this.nome_categoria_add;

      this.items_categoria.push(itemNovo);

      this.id_categoria_add = "";
    },

    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    datepicker_inputchanged(obj) {
      console.log(obj);
    },
    changed(prop) {},

    configureMessages() {
      const dict = {
        // email: {
        //   required: 'O e-mail não pode ser vazio!',
        //   email: 'É necessário informar um e-mail válido!'
        // },
        nome: {
          required: "Nome não pode ser vazio!"
        }
        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },
    salvar() {
      var self = this;

      if (!this.validar()) return false;

      self.msg_status = "Salvando..";
      self.loading = true;
      self.disableButton = true;
      self.form.data_validade = Util.dateToBd(self.data_validade);
      self.form.cliente_oculto = this.cliente_oculto ? 1 : 0;

      if (this.form["nome"] == null) {
        //alert("Dado indo inválido!");
        //return;
      }

      var hd_json = JSON.stringify(this.items_categoria);
      var ids_delete_json = JSON.stringify(this.ids_excluir_categoria);

      this.show_categoria_items = false;
      service
        .salvar(this.form)
        .then(function(response) {
          var retorno = response.data;

          var item = retorno.item;

          serviceItens
            .salvarGrid(hd_json, ids_delete_json, "modelo_checklist", item.id)
            .then(function(response2) {
              self.ids_excluir_categoria = [];
              // self.items_categoria = response2.data;
              self.msg_status = "Carregando..";
              self.loading = false;

              self.items_categoria = [];
              self.show_message = "on";
              self.message_text = "Modelo de checklist salvo com sucesso!";
              self.show_categoria_items = true;
              self.disableButton = false;

              self.interval_message = setInterval(self.clear_message, 6000);
            });

          self.form = item;

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
        })
        .catch(function(error) {});
    },

    excluir() {
      let self = this;
      self.msg_status = "Excluindo..";
      self.loading = true;

      var fn_return = function(response) {
        var retorno = response.data;
        if (self.onSave != null && self.onSave != undefined) {
          self.onSave(retorno, "delete");
        }
        self.msg_status = "Carregando..";
        self.loading = false;
        self.botao_voltar();
      };
      if (this.form.id == null) return false;

      service.delete(this.form.id).then(fn_return);
      //	obj_api.call_delete("cliente", this.id, fn_return);
    },
    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>